const paramTipiEnum = {
    1: "Metin",      // String
    2: "Tam Sayı",    // Int
    3: "Ondalık",     // Decimal
    4: "Mantıksal",   // Bool
    5: "Tarih",       // Date
    6: "Tarih ve Saat", // DateTime
    7: "Dönem"
};

export default paramTipiEnum;
